// d:/code/angrymiao-diy-2/frontend/web/src/utils/HostEvents.js

/**
 * @file 该文件用于记录所有由上位机（Qt/WebSocket服务）主动调用的事件名称。
 * 目的是为了集中管理和文档化这些全局回调，方便维护和防止拼写错误。
 */

// AM30 (Cyberboard Mouse) Events
const MOUSE_EVENTS = [
  'initMouseData',
  'updateMouseSet',
  'initMouseMacros',
  'updateMouseDPI',
  'updateMouseInfo',
  'updateFinish',
  'loadingFinish',
  'updateDPIButton',
  'updateFPS',
  'getAM30ProfileKeySwitch',
  'updateElectricity',
  'saveMousejson', // 导出JSON回调
];

// AM30 Firmware Events
const MOUSE_FIRMWARE_EVENTS = [
  'updateCurrentVer',
  'updateMouseProgress',
  'updateFinish', // 与AM30共用
];

// AM35 Events
const MOUSE_AM35_EVENTS = [
  'initAM35Data',
  'updateFinish', // 与AM30共用
  'loadingFinish', // 与AM30共用
  'updateDPIButton', // 与AM30共用
  'updatetAM35Battery',
  'setAM35Profile', // AM35 切换配置回调
  'getAM35ProfileKeySwitch', // AM35 组合键切换 Profile 开关上报
  'resetAM35', // 重置完成回调
  'saveAM35json', // 导出JSON回调（success/cancelled）
];

// AM35 Firmware Events
const MOUSE_AM35_FIRMWARE_EVENTS = [
  'updatetAM35Version',
  'updateMouseProgress', // 与AM30共用
  'updateFinish', // 与AM30共用
  'updateDevicesStatus', // AM35设备接入状态上报
  'update35MouseProgress', // AM35鼠标固件更新进度
  'update35DongleProgress', // AM35 Dongle固件更新进度
];

// System Events (系统事件)
const SYSTEM_EVENTS = [
  'setSystemInfo', // 设备列表信息
];

// 使用 Set 去重，然后转换回数组
const allEvents = [...new Set([
  ...MOUSE_EVENTS,
  ...MOUSE_FIRMWARE_EVENTS,
  ...MOUSE_AM35_EVENTS,
  ...MOUSE_AM35_FIRMWARE_EVENTS,
  ...SYSTEM_EVENTS,
])];

export const HostEvents = {
  all: allEvents,
  mouse: MOUSE_EVENTS,
  mouseFirmware: MOUSE_FIRMWARE_EVENTS,
  mouseAM35: MOUSE_AM35_EVENTS,
  mouseAM35Firmware: MOUSE_AM35_FIRMWARE_EVENTS,
  system: SYSTEM_EVENTS,
};
